import React, {useEffect, useRef, useState} from 'react';

const BuyerVideo = ({active, setActive}) => {
  const refVideo = useRef();

  useEffect(() => {
    if (!refVideo.current) {
      return;
    }

    refVideo.current.defaultMuted = true;
    refVideo.current.muted = true;
    refVideo.current.playsInline = true;
    refVideo.current.webkitPlaysinline = true;
    refVideo.current.play();

    refVideo.current.addEventListener('timeupdate', () => {
      if (refVideo.current.currentTime > 2 && active !== 1) {
        setActive(1);
      }

      if (refVideo.current.currentTime > 4 && active !== 2) {
        setActive(2);
      }

      if (refVideo.current.currentTime > 7 && active !== 1) {
        setActive(1);
      }
    });

    refVideo.current.addEventListener('ended', () => {
      setTimeout(() => {
        setActive(1);
      }, 500);
    });
  }, []);

  const playVideo = () => {
    if (!refVideo.current) {
      return;
    }

    setActive(0);

    refVideo.current.play();
  };

  return (
    <div className="pod-home-video">
      <video autoPlay muted ref={refVideo} onClick={playVideo}>
        <source src="/videos/buyer.mp4" type="video/mp4" />
      </video>
    </div>
  );
}

export default BuyerVideo;
